module.exports = __webpack_public_path__ + "static/media/cliente-lavoura-sul.4d24cea4.webp";